export const CARD_CLASS_NAME = 'kurama-Card'
